// src/lib/appRefresh.ts
// Централизованные функции обновления/сброса приложения.
// Используй их везде вместо прямого вызова clearAppCacheWithProgress.

import { clearAppCacheWithProgress } from '@/lib/utils'

function isTelegramWebViewCloseAvailable(): boolean {
  const webApp = window.Telegram?.WebApp
  if (!webApp || typeof webApp.close !== 'function') {
    return false
  }

  const hasInitData = typeof webApp.initData === 'string' && webApp.initData.length > 0
  const hasTelegramUser = Boolean(webApp.initDataUnsafe?.user?.id)

  if (hasInitData || hasTelegramUser) {
    return true
  }

  const url = new URL(window.location.href)
  const hasTelegramLaunchParams =
    Array.from(url.searchParams.keys()).some((key) => key.startsWith('tgWebApp')) ||
    url.searchParams.has('startapp') ||
    window.location.hash.includes('tgWebApp')

  return hasTelegramLaunchParams
}

function forceReloadWithCacheBust(): void {
  const nextUrl = new URL(window.location.href)
  nextUrl.searchParams.set('cache_bust', Date.now().toString())
  window.location.replace(nextUrl.toString())
}

function finishRefresh(action: 'reload' | 'close'): void {
  if (action === 'close' && import.meta.env.PROD && isTelegramWebViewCloseAvailable()) {
    window.Telegram.WebApp.close()
  } else {
    forceReloadWithCacheBust()
  }
}

/**
 * Мягкое обновление: чистит SW и браузерный кэш, сохраняет токен и Zustand-сторы.
 * Пользователь остаётся залогиненным. Используй для кнопки "Обновить приложение".
 */
export async function softRefresh(): Promise<void> {
  await clearAppCacheWithProgress({
    preserveAuthToken: true,
    preserveAuthStore: true,
    reload: false,
  })
  finishRefresh('reload')
}

/**
 * Жёсткий сброс: чистит всё включая токен и Zustand-сторы.
 * Пользователь будет разлогинен. Используй для "Выйти / Полный сброс"
 * или когда пользователь застрял на экране входа.
 */
export async function hardReset(): Promise<void> {
  await clearAppCacheWithProgress({
    preserveAuthToken: false,
    preserveAuthStore: false,
    reload: false,
  })
  finishRefresh('close')
}
